import { getAdminThemeStorageKey } from '@/constants/localStorage';

export type AdminTheme = 'light' | 'dark';

export function readStoredTheme(storageKey: string): AdminTheme | null {
  const raw = window.localStorage.getItem(storageKey);
  if (!raw) return null;

  if (raw === 'dark' || raw === 'light') return raw;

  try {
    const parsed = JSON.parse(raw) as unknown;
    if (parsed === 'dark' || parsed === 'light') return parsed;
  } catch {
    return null;
  }

  return null;
}

export function readStoredAdminTheme(userName: string): AdminTheme | null {
  if (!userName) return null;

  return readStoredTheme(getAdminThemeStorageKey(userName));
}

export function applyStoredAdminTheme(userName: string) {
  if (readStoredAdminTheme(userName) === 'dark') {
    document.documentElement.classList.add('dark');
  }
}
